// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "9809afaee663b742","460": "03476369053b3b28","917": "2a803eb88908645d","985": "46a5001e551435ee",}[chunkId] + ".chunk.js"
}